
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'div',
    { staticClass: 'su-navbar' },
    [
      _c(
        'b-navbar',
        { staticClass: 'flex-md-column navbar-dark', attrs: { toggleable: 'md' } },
        [
          _c('b-navbar-brand', { attrs: { href: '/' } }, [
            _c('img', {
              staticClass: 'd-inline-block align-top',
              attrs: { src: '/assets/img/logo.svg', alt: 'Show Up Logo' },
            }),
          ]),
          _c(
            'b-navbar-toggle',
            {
              ref: 'navToggle',
              staticClass: 'second-button',
              attrs: { target: 'nav-collapse' },
              on: { click: _vm.toggleButton },
            },
            [
              _c('div', { staticClass: 'animated-icon2', class: { open: _vm.isMenuOpen } }, [
                _c('span'),
                _c('span'),
                _c('span'),
                _c('span'),
              ]),
            ],
          ),
          _c(
            'b-collapse',
            { attrs: { id: 'nav-collapse', 'is-nav': '' } },
            [
              _c(
                'b-navbar-nav',
                { staticClass: 'flex-column' },
                [
                  _c(
                    'b-nav-item',
                    { class: { active: _vm.aboutActive }, attrs: { href: '#about-us' } },
                    [_vm._v('About us')],
                  ),
                  _c(
                    'b-nav-item',
                    { class: { active: _vm.knowActive }, attrs: { href: '#know-how' } },
                    [_vm._v('Our know-how')],
                  ),
                  _c(
                    'b-nav-item',
                    { class: { active: _vm.servicesActive }, attrs: { href: '#services' } },
                    [_vm._v('Our services')],
                  ),
                  _c(
                    'b-nav-item',
                    { class: { active: _vm.showsActive }, attrs: { href: '#shows' } },
                    [_vm._v('Our shows')],
                  ),
                  _c(
                    'b-nav-item',
                    { class: { active: _vm.contactActive }, attrs: { href: '#contact-us' } },
                    [_vm._v('Contact us')],
                  ),
                  _c(
                    'b-nav-item',
                    { class: { active: _vm.workActive }, attrs: { href: '#work-with-us' } },
                    [_vm._v('Work with us')],
                  ),
                  _c('b-nav-item', { attrs: { href: '/partners' } }, [_vm._v('Our partners')]),
                ],
                1,
              ),
            ],
            1,
          ),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [];

export default Vue.extend({
  render,
  staticRenderFns,
  name: 'MainNav',
  data() {
    return {
      isMenuOpen: false,
      aboutActive: false,
      knowActive: false,
      servicesActive: false,
      showsActive: false,
      contactActive: false,
      workActive: false,
    };
  },
  methods: {
    toggleButton() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    setFocus(index: number) {
      this.aboutActive = index === 1;
      this.knowActive = index === 2;
      this.servicesActive = index === 3;
      this.showsActive = index === 4;
      this.contactActive = index === 5;
      this.workActive = index === 6;
    },
    setNotFocus(_index: number) {
      this.aboutActive = false;
      this.knowActive = false;
      this.servicesActive = false;
      this.showsActive = false;
      this.contactActive = false;
      this.workActive = false;
    },
  },
});
